const API_URL = "/api";

export const REQUEST_STATS = "REQUEST_STATS";
export const RECEIVE_STATS = "RECEIVE_STATS";

const requestStats = () => ({ type: REQUEST_STATS });
const receiveStats = stats => ({ type: RECEIVE_STATS, stats });

export const fetchStats = () => {
  return dispatch => {
    dispatch(requestStats());

    fetch(API_URL + "/stats")
      .then(response => response.json())
      .then(stats => dispatch(receiveStats(stats)));
  };
};

export const REQUEST_FIND_CHANNEL = "REQUEST_FIND_CHANNEL";
export const RECEIVE_FIND_CHANNEL = "RECEIVE_FIND_CHANNEL";

const requestFindStation = () => ({ type: REQUEST_FIND_CHANNEL });
const receiveFindStation = data => ({ type: RECEIVE_FIND_CHANNEL, data });

export const fetchFindStation = (latitude, longitude) => {
  return dispatch => {
    dispatch(requestFindStation());

    const url = API_URL + `/channel/search?lat=${latitude}&lng=${longitude}`;

    fetch(url)
      .then(response => response.json())
      .then(data => dispatch(receiveFindStation(data)));
  };
};

export const REQUEST_INACTIVE_CHANNELS = "REQUEST_INACTIVE_CHANNELS";
export const RECEIVE_INACTIVE_CHANNELS = "RECEIVE_INACTIVE_CHANNELS";

const requestInactiveChannels = page => ({
  type: REQUEST_INACTIVE_CHANNELS,
  data: { page }
});
const receiveInactiveChannels = (page, channels) => ({
  type: RECEIVE_INACTIVE_CHANNELS,
  data: {
    page,
    channels
  }
});

export const fetchInactiveChannels = (page, country) => {
  return dispatch => {
    dispatch(requestInactiveChannels());

    let url = API_URL + `/channel/inactive?page=${page}`;
    if (country) {
      url += `&country=${country}`;
    }

    fetch(url)
      .then(response => response.json())
      .then(data => dispatch(receiveInactiveChannels(page, data)));
  };
};

const NOMINATIM_URL = "https://nominatim.openstreetmap.org/search";

export const REQUEST_LOCATION_SEARCH = "REQUEST_LOCATION_SEARCH";
export const RECEIVE_LOCATION_SEARCH = "RECEIVE_LOCATION_SEARCH";

const requestLocationSearch = () => ({ type: REQUEST_LOCATION_SEARCH });
const receiveLocationSearch = data => ({ type: RECEIVE_LOCATION_SEARCH, data });

export const fetchLocationSearch = city => {
  return dispatch => {
    dispatch(requestLocationSearch());

    const url = new URL(NOMINATIM_URL);
    url.searchParams.append("format", "json");
    url.searchParams.append("q", city);
    url.searchParams.append("limit", 10);

    fetch(url)
      .then(response => response.json())
      .then(data => dispatch(receiveLocationSearch(data)));
  };
};
